import React, { useState, useCallback, useEffect } from 'react';
import Modal from 'react-responsive-modal';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { hideModal } from '../../actions/internal';
import ASQModal from './ASQModal';
import BulkSendingModal from '../bulksending/BulkSendingModal';
import PlayerQuestionModal from '../../components/player/PlayerQuestionModal';
import QuestionNotesModal from '../notes/QuestionNotesModal';
import SurveyNotesModal from '../notes/SurveyNotesModal';
import AccountPlayersReportDetailsModal from './AccountPlayersReportDetailsModal';
import CommunicationMessageModalContainer from './CommunicationMessageModalContainer';
import GroupCohortsReportDetailsModal from './GroupCohortsReportDetailsModal';
import AsqSurveysReportDetailsModal from './AsqSurveysReportDetailsModal';
import FollowUpSurveysReportDetailsModal from './FollowUpSurveysReportDetailsModal';
import AsqSurveyEmailSendoutConfirmationModal from '../../components/player/AsqSurveyEmailSendoutConfirmationModal';

import 'react-responsive-modal/styles.css';

const MODAL_COMPONENTS = {
  'BULK_SENDING': BulkSendingModal,
  'START_ASQ': ASQModal,
  'QUESTION_DETAILS': PlayerQuestionModal,
  'QUESTION_NOTES': QuestionNotesModal,
  'SURVEY_NOTES': SurveyNotesModal,
  'ACCOUNT_PLAYERS_REPORT_DETAILS': AccountPlayersReportDetailsModal,
  'USER_ACTIONS_REPORT_DETAILS': AccountPlayersReportDetailsModal,
  'GROUP_COHORTS_REPORT_DETAILS': GroupCohortsReportDetailsModal,
  'ASQ_SURVEYS_REPORT_DETAILS': AsqSurveysReportDetailsModal,
  'FOLLOW_UP_SURVEYS_REPORT_DETAILS': FollowUpSurveysReportDetailsModal,
  'ASQ_SURVEY_EMAIL_SENDOUT_CONFIRMATION': AsqSurveyEmailSendoutConfirmationModal,
  'COMMUNICATION_NEW_MESSAGE': CommunicationMessageModalContainer,
}

export const closeIconPath = () => {
  return (<path fill="#32CDFF" d="M21.967 8.032c.481.48.47.948-.03 1.406l-5.563 5.625 4.938 5.5c.46.458.46.928 0 1.407s-.938.468-1.438-.032l-4.938-5.5-5.498 5.5c-.46.5-.919.51-1.376.032-.458-.48-.458-.95 0-1.407l5.563-5.625-4.938-5.5c-.459-.458-.459-.926 0-1.406.46-.48.937-.47 1.438.03l4.938 5.502 5.498-5.501c.46-.5.928-.51 1.406-.031M28 15c0-3.583-1.27-6.645-3.812-9.187C21.644 3.272 18.582 2 15 2c-3.582 0-6.645 1.27-9.188 3.812-2.54 2.542-3.81 5.604-3.81 9.187 0 3.584 1.27 6.646 3.81 9.188C8.354 26.73 11.417 28 15 28c3.583 0 6.645-1.27 9.188-3.812C26.728 21.646 28 18.584 28 15m2 0c0 4.126-1.47 7.657-4.406 10.595C22.654 28.532 19.124 30 15 30c-4.124 0-7.655-1.468-10.594-4.405C1.47 22.657 0 19.125 0 15c0-4.124 1.47-7.655 4.405-10.592C7.345 1.47 10.875 0 15 0c4.125 0 7.655 1.47 10.594 4.408C28.53 7.345 30 10.876 30 15" />);
}

const ModalRoot = ({ dispatch, modalType, modalProps }) => {
  const [extraClasses, setExtraClasses] = useState({});

  useEffect(() => {
    setExtraClasses({});
  }, [modalType]);

  const handleModalClassChange = useCallback((classMap) => {
    setExtraClasses((prev) => ({ ...prev, ...classMap }));
  }, []);

  if (isEmpty(modalType)) return null;
  const SpecificModal = MODAL_COMPONENTS[modalType];
  const { modalCssClass } = modalProps;
  const cssClass = classNames('o-modal', 'u-margin-top--large', modalCssClass, extraClasses);
  return (
    <Modal
      classNames={{ overlay: 'o-modal__wrap', modal: cssClass }}
      closeIconSvgPath={closeIconPath()}
      closeOnOverlayClick={true}
      open={!isEmpty(modalType)}
      onClose={() => dispatch(hideModal())}
      center={true}>
      <SpecificModal {...modalProps} onModalClassChange={handleModalClassChange} />
    </Modal>
  );
}

ModalRoot.propTypes = {
  dispatch: PropTypes.func.isRequired,
  modalType: PropTypes.string,
  modalProps: PropTypes.object.isRequired,
}

export default connect(
  state => state.modal
)(ModalRoot)
